import { createFileRoute } from "@tanstack/react-router";
import { alternatePath } from "@/lib/i18n";
import { buildHead, breadcrumbJsonLd, webPageJsonLd } from "@/lib/seo";
import { setEdgeHtmlCache } from "@/lib/cache-headers";

const PATH = "/about";
const DESCRIPTION =
  "Company dossier for Shugert: Shopify Partner since 2015, 750+ engagements, senior delivery governance, documented scopes, controlled releases, and measurable validation.";
const MODIFIED = "2026-08-19T00:00:00.000Z";

export const Route = createFileRoute("/about/")({
  loader: async () => {
    await setEdgeHtmlCache();
  },
  head: () =>
    buildHead({
      locale: "en",
      title: "About Shugert: Senior Shopify Engineering Firm",
      description: DESCRIPTION,
      path: PATH,
      altPath: alternatePath(PATH, "es"),
      jsonLd: [
        webPageJsonLd({
          name: "About Shugert: Senior Shopify Engineering Firm",
          path: PATH,
          description: DESCRIPTION,
          inLanguage: "en-US",
          dateModified: MODIFIED,
        }),
        breadcrumbJsonLd([
          { name: "Home", path: "/" },
          { name: "About", path: PATH },
        ]),
      ],
    }),
});
